import { cn } from "@/lib/utils";

interface MaxSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function MaxSpinner({ className, size = "md" }: MaxSpinnerProps) {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8"
  };

  return (
    <img
      src="/max-logo-triangle.png"
      alt="Loading..."
      className={cn(
        "max-logo-spinner inline-block object-contain",
        sizeClasses[size],
        className
      )}
      style={{ aspectRatio: '1' }}
    />
  );
}